import React from 'react';
import { Container } from './Container';
import { Label } from './Label';
import { Button } from './Button';
export function Closer() {
  return <section className="py-[clamp(80px,12vw,180px)] text-center" id="contact" data-id="element-34" data-mp="2f3ypnzhveybz">
      <Container data-id="element-35" data-mp="2suajq3y0n75r">
        <Label data-id="element-36" data-mp="2sutzpf43vlh5">05 · Get in touch</Label>
        <h2 className="mt-[24px] mb-[40px] text-[clamp(2.6rem,8vw,7rem)] font-black leading-[0.95] tracking-[-0.03em]" data-id="element-37" data-mp="2nwskx6dpq8bh">
          Got something
          <br data-id="element-38" data-mp="207gbc5eh3y8n" />
          worth building?
        </h2>
        <p className="text-[clamp(16px,1.4vw,19px)] max-w-[640px] mx-auto mb-[40px] leading-[1.5] text-[#2a2a2a]" data-id="element-39" data-mp="1w5me673hlcd8">
          We're picky about who we partner with. If we're a fit, we're all in.
        </p>
        <Button href="/contact" variant="solid" data-id="element-40" data-mp="255hsulw93pi0">
          Start a project
        </Button>
      </Container>
    </section>;
}